import { useDispatch } from "react-redux";
import { TOKEN_NAME } from "../../utils/constants";
import { clearUser, setLoggedInUser } from "../../redux/slices/logged_in_user";
import Cookies from 'js-cookie';
import { setAuthorization } from "../../services/axios_client";
import { useEffect } from "react";
import AuthService from "../../services/auth";
import { useNavigate } from "react-router-dom";

export const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authService = new AuthService();

  useEffect(() => {
    const initAuth = async () => {
      const token = Cookies.get(TOKEN_NAME);

      if (token) {
        setAuthorization(token);

        try {
          const response = await authService.verify();
          dispatch(setLoggedInUser(response.data));
        } catch (error) {
          const isForbiddenIpError = error?.status === 403 && error?.message === "ip-blocked";
          if (isForbiddenIpError) {
            return navigate("/blocked", { replace: true });
          }
          if (error?.status === 401) {
            Cookies.remove(TOKEN_NAME);
            dispatch(clearUser());
          }
        }
      } else {
        // Không có token
        dispatch(clearUser());
      }
    };

    initAuth();
  }, [dispatch, navigate]);
};